module.exports = (...methods) => {

  return (result) => {

    return methods.reduceRight((result, method) => {

      return method(result)

    }, result)

  }

}



// WEBPACK FOOTER //
// ../node_modules/berries/lib/compose.js